import { useMe as p } from "../../../hooks/useMe.js";
const L = _ref => {
  let {
    teamKey: g,
    enableExternalData: n,
    externalData: o,
    disableUsernameTruncation: m
  } = _ref;
  var t, u;
  const {
      meData: d,
      meIsLoading: P
    } = p({
      teamKey: g,
      cancelFetch: n
    }),
    b = n ? (t = o == null ? void 0 : o.meIsLoading) != null ? t : !1 : P,
    e = n ? o : d,
    {
      nickname: l,
      facebookPictureUrl: a,
      googlePictureUrl: f,
      publicAccountId: r,
      configs: c
    } = e != null ? e : {},
    I = (u = a != null ? a : f) != null ? u : "",
    U = !!(e != null && e.nickname) || !!(e != null && e.facebookPictureUrl) || !!(e != null && e.googlePictureUrl),
    i = !!(c != null && c.contatoPro);
  let s = "";
  return l && (s = l.length < 16 || m && i ? l : "".concat(l.substring(0, 15), "\u2026")), {
    isLogged: U,
    profilePicture: I,
    userName: s,
    publicAccountId: r != null ? r : "",
    meIsLoading: b,
    isAutosPro: i
  };
};
export { L as useGetLoginInfo };